import httpClient from "../api/httpClient";
const actionScope = `loader`;
import Vue from "vue";
import router from "@/router";

export function setupInterceptors({ dispatch }) {
  var eventBus = new Vue({ router });
  let requestsPending = 0;
  const req = {
    pending: () => {
      requestsPending++;
      dispatch(`${actionScope}/show`);
    },
    done: () => {
      requestsPending--;
      if (requestsPending <= 0) {
        dispatch(`${actionScope}/hide`);
      }
    },
  };
  httpClient.interceptors.request.use(
    (config) => {
      req.pending();
      return config;
    },
    (error) => {
      requestsPending--;
      req.done();
      return Promise.reject(error);
    }
  );
  httpClient.interceptors.response.use(
    (data) => {
      req.done();
      return Promise.resolve(data);
    },
    (error) => {
      req.done();
   
      if (error.message === "Network Error") {
        console.log(error);
        eventBus.$message({
          showClose: true,
          message: "Network Hatası",
          type: "error",
        });
        return;
      }
      if (error.response.status == 401) {
        window.sessionStorage.removeItem("BearerToken");
        eventBus.$router.push("/login");
        return;
      }

      eventBus.$message({
        showClose: true,
        message: error.response.data.message,
        type: "error",
      });
      //TO-DO status control - go login- error handler
      //alert(error.response.data.message);

      return Promise.reject(error);
    }
  );
}
